import React from "react";
import { connect } from "react-redux";

import Toggle from "material-ui/Toggle";
import { muiToggleStyle, Text } from "ui-components";

import Comment from "@common/components/Comment";
import AppendixDialog from "@common/components/AppendixDialog";
import RiskSectionInfo from "@common/components/RiskSectionInfo";
import {
  toggleAppendixTip,
  toggleSuggestedTip,
  upsertSuggestedTip,
  deleteSuggestedTip
} from "@previsit/components/Content/actions";
import { LayoutWrapper, LayoutHeader, LayoutBody } from "@common/styled/layout";
import {
  RiskListHeader,
  RiskSelectorWrapper,
  RiskSelectorContent,
  RiskSelectorText,
  RiskSelectorButtons,
  RiskSelectorToggleLabel
} from "@common/styled/risk";

class RiskSelector extends React.Component {
  render() {
    const { risk, riskKey, toggleIndicator } = this.props;

    return (
      <RiskSelectorWrapper>
        <RiskSelectorContent>
          <RiskSelectorText>
            {risk.question}
          </RiskSelectorText>
          <RiskSelectorButtons onClick={() => toggleIndicator(riskKey)}>
            <RiskSelectorToggleLabel>No</RiskSelectorToggleLabel>
            <Toggle
              label="Yes"
              toggled={risk.isRisk}
              style={muiToggleStyle.style}
              labelPosition="right"
              labelStyle={muiToggleStyle.label}
            />
          </RiskSelectorButtons>
        </RiskSelectorContent>
      </RiskSelectorWrapper>
    );
  }
}

class Body extends React.Component {
  render() {
    const {
      subsection,
      commentValue,
      updateComment,
      toggleIndicator,
      isAppendixDialogShown,
      hideAppendixDialog
    } = this.props;

    const risks = subsection.risks;

    return (
      <LayoutWrapper>
        <LayoutHeader>
          <Text size={4} type="bold">
            Assessment Item
          </Text>
          <Text size={5}>
            (Sample questions to ask during phone interview)
          </Text>
        </LayoutHeader>
        <LayoutBody>
          <RiskListHeader>Risk Identification</RiskListHeader>
          {Object.keys(risks).map((key, index) => {
            let currentRisk = risks[key];
            return (
              <RiskSelector
                key={index}
                risk={currentRisk}
                riskKey={key}
                toggleIndicator={toggleIndicator}
              />
            );
          })}
          <RiskSectionInfo
            suggestedTips={subsection.suggestedTips}
            checkedAppendixTips={subsection.checkedAppendixTips}
          />
          <Comment
            onBlur={e => updateComment(e.target.value)}
            value={commentValue}
          />
          <AppendixDialog
            subsectionIdx={0}
            isShown={isAppendixDialogShown}
            toggleDialog={hideAppendixDialog}
            section={subsection}
            onAppendixTipClick={this.props.toggleAppendixTip}
            onSuggestedTipClick={this.props.onSuggestedTipClick}
            upsertSuggestedTip={this.props.upsertSuggestedTip}
            deleteSuggestedTip={this.props.deleteSuggestedTip}
          />
        </LayoutBody>
      </LayoutWrapper>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return {
    toggleAppendixTip: tipInfo => dispatch(toggleAppendixTip(tipInfo)),
    onSuggestedTipClick: tipInfo => dispatch(toggleSuggestedTip(tipInfo)),
    upsertSuggestedTip: tipInfo => dispatch(upsertSuggestedTip(tipInfo)),
    deleteSuggestedTip: tipInfo => dispatch(deleteSuggestedTip(tipInfo))
  };
}

export default connect(null, mapDispatchToProps)(Body);



// WEBPACK FOOTER //
// ./src/previsit/components/Content/Body/Body.jsx